import styled, { css } from 'styled-components';

export const MapContainer = styled.a`
  ${({ theme, ...props }) => {
    return css`
      position: relative;
      display: block;
      width: 100%;
      height: 6rem;
      border-radius: ${theme.radius.xs};
      overflow: hidden;
      margin: 1rem 0 0 0;
      img {
        object-fit: cover;
      }
    `;
  }};
`;
